<template>
    <el-drawer
            :title="$t('Follow_the_set')"
            :before-close="closeHandle"
            v-if="masterAccountEditSubscrpitDialogShow"
            :visible="masterAccountEditSubscrpitDialogShow"
            direction="rtl"
            custom-class="copy-shell"
            :show-close="true"
            :close-on-press-escape="true"
            ref="drawer"
    >
        <div class="drawer-content pr"
        >
            <el-scrollbar style="height: 100%;"> <!-- 滚动条 -->
                <div class="subscript-box pr">
                    <div class="social">
                        <div class="first-step">
                            <div class="social-title copytype-title">{{masterAccountEditSubscrpitDialogType}}{{$t('Master_account_special')}}</div>
                            <div class="social-info">
                                <div class="nickname">{{masterAlias}}</div>
                                <div class="list-content">
                                    <p class="card-line">
                                        <span class="span-el">{{$t('Minimum_funding_limit')}}</span>
                                        <span class="line"></span>
                                        <span class="span-el">
                                            {{moneyLimit || 0}} USD
                                        </span>
                                    </p>

                                    <p class="card-line" v-if="mamFollowSettingText">
                                        <span class="span-el">{{$t('User.balance')}}</span>
                                        <span class="line"></span>
                                        <span class="span-el">
                                            {{balance}} USD
                                        </span>
                                    </p>
                                    <p class="card-line" v-if="mamFollowSettingText">
                                        <span class="span-el">{{$t('User.leverage')}}</span>
                                        <span class="line"></span>
                                        <span class="span-el">
                                            {{leverage}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="social-title copytype-title">{{masterAccountEditSubscrpitDialogType}}{{$t('Investment_account')}}</div>
                            <div class="follow-info">
                                <div class="follow-item social-info"
                                     v-for="(item,index) in copyingSelectData"
                                     :key="index"
                                >
                                    <div class="nickname"
                                    >{{item.copyAlias}}</div>
                                    <template v-if="mamFollowSettingText">
                                        <p class="card-line">
                                            <span class="span-el">{{$t('Manage_funds')}}</span>
                                            <span class="line"></span>
                                            <span class="span-el">
                                            {{item.managementAmount}} USD
                                        </span>
                                        </p>
                                        <p class="card-line">
                                            <span class="span-el">{{$t('User.leverage')}}</span>
                                            <span class="line"></span>
                                            <span class="span-el">
                                            {{item.copyLeverage}}
                                        </span>
                                        </p>
                                    </template>
                                </div>

                            </div>
                            <el-form
                                    ref="form"
                                    :model="form"
                                    :rules="rules"
                            >
                                <el-form-item prop="copyType">
                                    <p class="self-label">{{$t('Allocation')}}</p>
                                    <el-radio v-model="form.copyType" :label="3">{{$t('Smart_proportion')}}</el-radio>
                                    <el-radio v-model="form.copyType" :label="2">{{$t('fixed_proportion')}}</el-radio>
                                    <el-radio v-model="form.copyType" :label="1">{{$t('fixed_lots')}}</el-radio>
                                </el-form-item>
                                <el-form-item prop="copyValue">
                                    <p class="self-label">{{copyValueLabel}}</p>
                                    <div class="copyvalue-box pr">
                                        <el-input
                                                v-model="form.copyValue"
                                                class="copy-value-input"
                                                :placeholder="phFileter('please_enter')"
                                        >
                                        </el-input>
                                        <span class="pa copytype-text">{{copyTypeText}}</span>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="copyMaxNum">
                                    <p class="self-label">{{$t('Maximum_follow_number')}}</p>
                                    <div class="copyvalue-box pr">
                                        <el-input
                                                v-model="form.copyMaxNum"
                                                class="copy-value-input"
                                                :placeholder="phFileter('Unlimited')"
                                        >
                                        </el-input>
                                        <span class="pa copytype-text">{{$t('transactions')}}</span>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="copyMaxLots">
                                    <p class="self-label">{{$t('Maximum_follow_lot')}}</p>
                                    <div class="copyvalue-box pr">
                                        <el-input
                                                v-model="form.copyMaxLots"
                                                class="copy-value-input"
                                                :placeholder="phFileter('Unlimited')"
                                        >
                                        </el-input>
                                        <span class="pa copytype-text">{{$t('Home.forexLot')}}</span>
                                    </div>
                                </el-form-item>
                                <el-form-item>
                                    <p class="self-label">{{$t('Follow_the_order')}}</p>
                                    <el-switch
                                            v-model="form.followOrder"
                                            active-color="#13ce66"
                                            inactive-color="#cccccc"
                                    ></el-switch>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="footer-box">
                <div class="first-step-done">
                    <div class="btn-box">
                        <el-button :loading="loading" class="next-btn step-btn" type="primary" @click="submitHandle">{{$t('User.saveSetting')}}</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    // mam主账户和social主账户编辑订阅弹框
    import { updateSubscription,queryMasterTraderInfo } from '@/api/copy'
    import { mapGetters } from 'vuex'
    import { valiteTwofixAndInt } from '@/utils/validate'
  export default {
    name: 'mamMasterAndSocialSubAccountEditSubscrpitDialog',
    components:{
    },
    data() {
      let  _this = this;
      let validateCopyValue = (rule, value, callback) => {
        if(this.form.copyType == 3){
          if(value === ''){
            callback();
          }else {
            if(!valiteTwofixAndInt(value)){
              callback(new Error(_this.$t('copyValidateTips')));
            }else {
              callback();
            }
          }
          callback();
        }else {
          if(value === ''){
            callback(new Error(_this.$t('copyValueNullValidateTips')));
            return;
          }else {
            if(!valiteTwofixAndInt(value)){
              callback(new Error(_this.$t('copyValidateTips')));
            }else {
              callback();
            }
          }
        }
      }
      return {
        loading: false,
        masterAlias: '',
        moneyLimit: 0,
        balance: '',
        leverage: '',
        form:{
          copyType: 1,
          copyValue: '',
          copyMaxLots: '',
          copyMaxNum: '',
          followOrder: true,
        },
        rules:{
          copyValue: [
            {validator: validateCopyValue, trigger: 'blur'}
          ],
        },
      };
    },
    computed: {
      ...mapGetters(['masterAccountEditSubscrpitDialogShow','masterAccountEditSubscrpitDialogType','userInfo','copyNeedPass','agreementFile','copyingSelectData','masterAccountEditSubscrpitParams','currentMasterMtId','listRefresh']),
      copyValueLabel(){
        switch (this.form.copyType) {
          case 3:
            return this.$t('maximum_ratio');
          case 2:
            return this.$t('fixed_proportion');
          case 1:
            return this.$t('fixed_lots');
        }
      },
      copyTypeText(){
        switch (this.form.copyType) {
          case 3 :
            return this.$t('multiple');
          case 2 :
            return this.$t('multiple');
          case 1:
            return this.$t('Home.forexLot');
        }
      },
      notFunds(){
        return true;
      },
      mamFollowSettingText(){
        return this.masterAccountEditSubscrpitDialogType == 'mam';
      }
    },
    watch:{
      masterAccountEditSubscrpitParams:{
        handler(newValue,oldValue){
            this.form.copyType = newValue.copyType || 1;
            this.form.copyValue = newValue.copyValue || '';
            this.form.copyMaxNum = newValue.copyMaxNum;
            this.form.copyMaxLots = newValue.copyMaxLots;
            this.form.followOrder = newValue.copyStatus == 1? true: false;
        },
        deep: true,
      },
      masterAccountEditSubscrpitDialogShow(newValue){
        if(newValue){
          this.queryMasterInfo();
        }
      }
    },
    methods: {
      closeHandle() {
        this.$store.commit('setMasterAccountEditSubscrpitDialogShow', false);
      },
      queryMasterInfo(){
        queryMasterTraderInfo({
          masterMtId: this.currentMasterMtId,
          isCreate: false
        }).then((res) => {
          this.moneyLimit = res.data.content[0].subAmount;
          this.masterAlias = res.data.content[0].alias;
          this.balance = res.data.content[0].signalBalance;
          this.leverage = res.data.content[0].signalLeverage;
        })
      },
      phFileter(data) {
        return this.$t(data);
      },
      submitHandle(){
        this.$refs.form.validate((valid) => {
          if(valid){
            this.loading = true;
            let params = {
              ids: this.getIds(),
              copyType: this.form.copyType,
              copyValue: this.form.copyValue,
              copyMaxNum: this.form.copyMaxNum,
              copyMaxLots: this.form.copyMaxLots,
              copyStatus: this.form.followOrder == true? 1: 0,
            }
            if(this.masterAccountEditSubscrpitDialogType !== 'social'){
              params.isMaster = true;
            }
            updateSubscription(params).then((res) => {
              this.loading = false;
                this.$message({
                  type: 'success',
                  message: this.$t('Follow_Settings_Successfully')
                });
              this.$store.commit('setListRefresh',!this.listRefresh);
                setTimeout(() => {
                  this.closeHandle();
                }, 1000);
            }).catch(() => {
              this.loading = false;
            })
          }else {
            console.log('error');
          }
        })
      },
      getIds(){
        let ids = [];
        for (let i = 0; i <this.copyingSelectData.length ; i++) {
          ids.push(this.copyingSelectData[i].id);
        }
        return ids;
      }
    }
  };
</script>
<style lang="scss">
    .open-account-drawer  {
        .el-select{
            width: 100%;
        }
    }
</style>
<style lang="scss" scoped>
    @import "../../../../assets/scss/variable";
    .drawer-content {
        height: calc(100vh - 64px - 100px);
        border-top: 1px solid #E6E6E6;
    }
    .footer-box {
        padding: 10px 20px;
    }

    .subscript-box {
        padding: 20px;
        .copytype-title {
            margin-bottom: 5px;
        }
        .social-info {
            background-color: #F6F8FA;
            padding: 15px;
            margin-bottom: 25px;
            .nickname {
                font-size: 14px;
                color: #333333;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .money-limit {
                color: #999999;
            }
        }
        .copytype-text {
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
        }
        .copyCount-btn-outer {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .month-btn {
                display: inline-block;
                width: 20px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                cursor: pointer;
            }
            .sub-btn {
                color: $themeColor;
                border: 2px solid $themeColor;
                font-weight: bold;
            }
            .add-btn {
                background-color: $themeColor;
                color: #ffffff;
            }
            .copyCount {
                display: inline-block;
                line-height: 20px;
                padding: 0 10px;
            }
        }
        .follow-info {
            margin-bottom: 30px;
        }
        .follow-item {
            margin-bottom: 5px;
        }
    }
    .step-btn {
        width: 100%;
    }
    .next-btn {
        margin-top: 20px;
    }
    .list-content {
        color: #999999;
    }
    .card-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 28px;
        font-size: 13px;
        .span-el {
            display: block;
            color: #999999;
            &:last-of-type {
                white-space: nowrap;
            }
        }
        .line {
            flex: 1;
            height: 0;
            border-bottom: 1px dashed #E6E6E6;
            margin: 0 5px;
        }
    }
</style>
